import { useContext } from 'react'
import { MiniAppContext } from '../../ui/miniapp-provider'

export const useMiniApp = () => {
    const context = useContext(MiniAppContext)
    if (context === null) {
        throw new Error('useMiniApp должен использоваться внутри MiniAppProvider')
    }
    return context
}
